import { connect } from 'react-redux'
import { StaticQuestionSlide } from '@plickers/now-player-library/chrome'
import { isContentAllowed, revisitConsent } from '../../utils/cookieHelpers'

//
// The shared library's StaticQuestionSlide renders the library's own RichStaticSlide,
// not web's connected wrapper, so it would default `youtubeAllowed` to true. It
// spreads its props into the renderer, so supplying the flag here covers every call
// site, the same way richStaticSlide/RichStaticSlide.js does.
//
function mapStateToProps(state) {
  return {
    youtubeAllowed: isContentAllowed('youtube', state.cookieConsents),
    // "manage settings" on the blocked-YouTube overlay; the library cannot reach OneTrust.
    onRevisitConsent: revisitConsent,
  }
}

export default connect(mapStateToProps)(StaticQuestionSlide)
